<div class="ri-bg-dark-4">
    <router-outlet />
</div>
